function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { hfComplianceApi } from '@atheneum/api';
import { formatDate } from '@atheneum/api/dist/lib';

class HFComplianceStatus extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "sendRequest", async e => {
      e.stopPropagation();
      e.preventDefault();
      const {
        growlStore,
        expert,
        callback
      } = this.props;

      try {
        await hfComplianceApi.sendRequest(expert.userId);
        growlStore.showSuccess('HF Compliance request sent.');
        callback && (await callback());
      } catch (error) {
        growlStore.showError(error);
      }
    });
  }

  render() {
    const {
      expert,
      hfCompliances,
      className,
      history
    } = this.props;
    const classes = className ? `compliance-wrapper ${className}` : 'compliance-wrapper'; // Take the first ones as they are sorted by created_at DESC on backend

    const latestRejectedHfCompliance = hfCompliances.find(hfc => hfc.isConfirmed === false);
    const latestConfirmedHfCompliance = hfCompliances.find(hfc => hfc.isConfirmed === true);
    const latestUnconfirmedHfCompliance = hfCompliances.find(hfc => hfc.isConfirmed === null);

    if (latestRejectedHfCompliance) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-label m-r-md"
      }, "HF Compliance rejected."));
    } else if (latestUnconfirmedHfCompliance) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: "danger-label m-r-md"
      }, "HF Compliance verification pending."), /*#__PURE__*/React.createElement("span", {
        className: "action-label link",
        onClick: e => {
          e.stopPropagation();
          e.preventDefault();
          history.push(`/expert/${expert.userId}/hf-compliance/${latestUnconfirmedHfCompliance.id}`);
        }
      }, "Review compliance"));
    } else if (latestConfirmedHfCompliance && expert.hfComplianceRequestedBy) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-label m-r-md"
      }, "HF Compliance in place since", ' ', formatDate(latestConfirmedHfCompliance.createdAt), ", renewal requested."), /*#__PURE__*/React.createElement("span", {
        className: "action-label link",
        onClick: this.sendRequest
      }, "Repeat request"));
    } else if (latestConfirmedHfCompliance) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-label m-r-md"
      }, "HF Compliance in place since", ' ', formatDate(latestConfirmedHfCompliance.createdAt), "."), /*#__PURE__*/React.createElement("span", {
        className: "action-label link",
        onClick: this.sendRequest
      }, "Request renewal"));
    } else if (expert.hfComplianceRequestedBy) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: "danger-label m-r-md"
      }, "HF Compliance requested."), /*#__PURE__*/React.createElement("span", {
        className: "action-label link",
        onClick: this.sendRequest
      }, "Repeat request"));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: "danger-label m-r-md"
      }, "HF Compliance not in place."), /*#__PURE__*/React.createElement("span", {
        className: "action-label link",
        onClick: this.sendRequest
      }, "Request hedge fund compliance"));
    }
  }

}

_defineProperty(HFComplianceStatus, "propTypes", {
  growlStore: PropTypes.object.isRequired,
  expert: PropTypes.object.isRequired,
  hfCompliances: PropTypes.object.isRequired,
  className: PropTypes.string,
  callback: PropTypes.func,
  history: PropTypes.object
});

export default withRouter(inject('growlStore')(observer(HFComplianceStatus)));